import React, { Component } from "react";
import "./style.less";
interface tabItem {
  key: string;
  value: string;

}
interface iProps {
  tabs: Array<tabItem>;
  updateVal:(key)=>void;

}
interface iState {
  tabActivekey: string;
}
export default class changeDataTab extends Component<iProps, iState> {
  state: iState = {
    tabActivekey: "",
  };
  componentDidMount(){
    this.clickTab(this.props.tabs?.[0].key)
  }

  clickTab = (key) => {
    this.setState({
      tabActivekey: key
    });
    this.props.updateVal(key)
  };
  render() {
    let {tabs} = this.props;
    return (
      <div className="changeDataTab">
        {(tabs ??[]).map((item, index) => (
            <div
              className={
                item.key === this.state.tabActivekey ? "tab tabActive" : "tab"
              }
              onClick={() => {
                this.clickTab(item.key);
              }}
              key={item.key}
            >
              {item.value}
            </div>
          ))}
      </div>
    );
  }
}
